import React from "react";

interface SelectableParticipantCardProps {
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
  leading: React.ReactNode;
  content: React.ReactNode;
  trailing?: React.ReactNode;
}

const SelectableParticipantCard = ({
  checked,
  disabled = false,
  onCheckedChange,
  leading,
  content,
  trailing,
}: SelectableParticipantCardProps): JSX.Element => {
  return (
    <label
      className={`flex items-start justify-between gap-3 rounded-xl border p-3 transition ${
        disabled ? "opacity-60" : "cursor-pointer"
      } ${
        checked
          ? "border-brand-200 bg-brand-50 dark:bg-brand-500/15"
          : "border-line bg-surface hover:bg-surface-hover"
      }`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onCheckedChange(event.target.checked)}
        />
        {leading}
        <div className="min-w-0">{content}</div>
      </div>
      {trailing ? <div className="flex flex-col items-end gap-1">{trailing}</div> : null}
    </label>
  );
};

export default SelectableParticipantCard;